import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import DateTag from "./DateTag";

const FlightDatesTag = (props) => (
  <DateTag icon={<FlightTakeoffIcon />} value={props.value} />
);

export default FlightDatesTag;
